const TabletLayout = function (windowSize, isMobile, isTablet, isIOS, isOpen, isFormFocused, isHovered, position, collapsedStyle, config) {
  var layout, wrapperStyle, clickWrapperStyle, swivlEmbedStyle, chatWrapperStyle;
  var arrowTransform = isOpen ? "rotate(0deg)" : "rotate(180deg)";

  layout = {
    position: position,
    width: 400,
    height: windowSize.height - 20,
    headerHeight: 55,
    leftPadding: 0,
    rightPadding: 0
  };

  wrapperStyle = {};
  clickWrapperStyle = {
    position: "fixed",
    // background:"#000",
    top: isOpen ? "20px" : "auto",
    bottom: isOpen ? "auto" : 0,
    left: "auto",
    right: "20px",
    height: isOpen ? layout.height + "px" : layout.headerHeight + "px",
    width: Math.min(layout.width, windowSize.width) + "px",
    transition: isOpen || true ? "all 0.4s cubic-bezier(.4,-.40,.19,1.1)" : "all 0.1s linear"
  };

  //// NOTE: We add 100 to the bottom of these so we dont pop out when it closes
  swivlEmbedStyle = {
    position: "absolute",
    left: 0,
    right: 0,
    height: layout.height + 100 + "px",
    width: Math.min(layout.width, windowSize.width) + "px",
    top: "0",
    transition: "all 0.2s linear",
    borderRadius: "25px",
    overflow: "hidden"
  };

  chatWrapperStyle = {
    position: "absolute",
    top: layout.headerHeight + "px",
    bottom: "100px",
    right: "0",
    left: "0"
  };

  if (position == "bottom-center") {
    clickWrapperStyle.right = (windowSize.width - layout.width) / 2 + "px";
  }

  if (position == "bottom-left") {
    clickWrapperStyle.left = "20px";
    clickWrapperStyle.right = "auto";
  }

  if (windowSize.width < layout.width + 72) {
    clickWrapperStyle.left = "auto";
    clickWrapperStyle.right = "auto";
  }

  if (position == "right" || position == "left") {
    const height = windowSize.height * 0.75;
    arrowTransform = isOpen ? "rotate(270deg)" : "rotate(90deg)";

    layout = {
      position: position,
      width: 400,
      height: Math.min(700, windowSize.height * 0.75),
      headerHeight: 55,
      peakGap: 30,
      leftPadding: 0,
      rightPadding: 40
    };

    clickWrapperStyle = {
      position: "fixed",
      top: (windowSize.height - height) / 2 + "px",
      bottom: "auto",
      right: "0",
      height: height + "px",
      width: isOpen ? layout.width + "px" : layout.headerHeight + "px",
      transition: isOpen || true ? "all 0.4s cubic-bezier(.4,-.40,.19,1.1)" : "all 0.1s linear",
      rightPadding: layout.rightPadding + "px"
    };

    swivlEmbedStyle = {
      position: "absolute",
      left: "0",
      height: height + "px",
      width: layout.width + 40 + "px",
      top: "0",
      bottom: "0",
      transition: isOpen || true ? "all 0.4s cubic-bezier(.4,-.40,.19,1.1)" : "all 0.1s linear",
      borderRadius: "25px 0 0 25px",
      overflow: "hidden"
    };

    chatWrapperStyle = {
      position: "absolute",
      top: layout.headerHeight + "px",
      bottom: "5px",
      right: layout.rightPadding + "px",
      left: "0"
    };

    if (position == "left") {
      arrowTransform = isOpen ? "rotate(90deg)" : "rotate(270deg)";

      layout.leftPadding = 40;
      layout.rightPadding = 0;
      clickWrapperStyle.right = "auto";
      clickWrapperStyle.left = "0";
      swivlEmbedStyle.left = "auto";
      swivlEmbedStyle.right = "0";

      swivlEmbedStyle.borderRadius = "0 25px 25px 0";

      chatWrapperStyle.right = "0";
      chatWrapperStyle.left = layout.leftPadding + "px";
    }
  }

  if (collapsedStyle == "dot") {
    if (position == "left") {
      clickWrapperStyle.left = isOpen ? "0" : "-60px";
    } else if (position == "right") {
      clickWrapperStyle.right = isOpen ? "0" : "-60px";
    } else {
      clickWrapperStyle.bottom = isOpen ? "0" : "-60px";
    }
  }

  return {
    layout: layout,
    wrapperStyle: wrapperStyle,
    clickWrapperStyle: clickWrapperStyle,
    swivlEmbedStyle: swivlEmbedStyle,
    chatWrapperStyle: chatWrapperStyle,
    arrowTransform: arrowTransform
  };
};

export default TabletLayout;
